<template>
  <div class="row">
    <div class="col-md-12 mt50">
      <h4>{{ $t('Por artículos') }}</h4>
			
      <div class="form-head fix">

        <usuario-input-autocomplete
          :title="'EAN - ISBN'" 
          searchField="codigo" 
          :searchCategory="'misconsultas/articulo'" :value.sync="frm.codigo"
          :reset="reset">      
        </usuario-input-autocomplete>

        <usuario-input-autocomplete
          :title=" $t('Título') " 
          searchField="titulo" 
          :searchCategory="'misconsultas/articulo'" :value.sync="frm.titulo"
          :reset="reset">      
        </usuario-input-autocomplete>

        <usuario-input-autocomplete
          :title=" $t('Autor/a - Intérprete - Director/a') " 
          searchField="autor" 
          :searchCategory="'misconsultas/articulo'" :value.sync="frm.autor"
          :reset="reset">      
        </usuario-input-autocomplete>

       <usuario-input-autocomplete
          :title=" $t('Editor') " 
          searchField="editor" 
          :searchCategory="'misconsultas/articulo'" :value.sync="frm.editor"
          :reset="reset">      
        </usuario-input-autocomplete>

        <usuario-input-autocomplete
          :title=" $t('Distribuidor') " 
          searchField="distribuidor" 
          :searchCategory="'misconsultas/articulo'" :value.sync="frm.distribuidor"
          :reset="reset">      
        </usuario-input-autocomplete>

        <usuario-custom-select-box
          :title="$t('Fecha del pedido')" 
          searchField="fecha" 
          :searchCategory="'misconsultas/articulo'" :value.sync="frm.fecha"
          :reset="reset">
        </usuario-custom-select-box>        

      </div>

     <!--  <div class="row">
        <div class="col-md-12"> -->
          <div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>
          <div class="center">
            <button class="btn btn-tata mb40" type="reset" @click="resetForm">{{ $t('Vaciar') }} <i class="fa fa-remove"></i></button>
            <button class="btn btn-tata mb40" type="submit" :disabled="loading" @click="submitSearch">{{ $t('Buscar') }} <i class="fa fa-search"></i></button>
          </div>
     <!--    </div>
      </div> -->

      <div v-if="loading" class="loading center"><img src="@/assets/img/loading.gif" alt=""></div>

      <template v-else>

        <div v-if="filteredData" class="download-excel align-right mb10">
          <a :href="getApiUrl + getLocale + '/' + enlaceExcel" class="buy-link todo" target="_blank"><i class="fa fa-file-excel-o"></i> {{ $t('Guardar') }} EXCEL</a>
          <br><br>
        </div>

        <table v-if="filteredData" class="table table-hover"> 
          <thead> 
            <tr> 
              <th></th>
              <th>#</th>
              <th @click="sortBy('fecha')">{{ $t('Fecha') }} <i class="fa fa-sort"></i></th>
              <th @click="sortBy('consorcio')">{{ $t('Proyecto') }} <i class="fa fa-sort"></i></th>
              <th @click="sortBy('referencia')">{{ $t('Referencia') }} <i class="fa fa-sort"></i></th>
              <th @click="sortBy('titulo')">{{ $t('Artículo') }} <i class="fa fa-sort"></i></th> 
              <th @click="sortBy('autor')">{{ $t('Autor') }} <i class="fa fa-sort"></i></th>
              <th @click="sortBy('codigo')">{{ $t('Código') }} <i class="fa fa-sort"></i></th> 
              <th @click="sortBy('cdu')">{{ $t('CDU') }} <i class="fa fa-sort"></i></th>
              <th @click="sortBy('cantidad')" width="36" class="align-right"><div class="rotate-90">{{ $t('Cantidad') }}</div> <i class="fa fa-sort"></i></th> 
              <th @click="sortBy('pendientes')" width="36" class="align-right"><div class="rotate-90">{{ $t('Pendientes') }}</div> <i class="fa fa-sort"></i></th> 
              <th @click="sortBy('enproceso')" width="36" class="align-right"><div class="rotate-90">{{ $t('En Proceso') }}</div> <i class="fa fa-sort"></i></th> 
              <th @click="sortBy('incidencias')" width="36" class="align-right"><div class="rotate-90">{{ $t('Incidencias') }}</div> <i class="fa fa-sort"></i></th> 
              <th @click="sortBy('albaranados')" width="36" class="align-right"><div class="rotate-90">{{ $t('Albaranados') }}</div> <i class="fa fa-sort"></i></th> 
              <th width="60"></th>    
            </tr> 
          </thead> 
          <tbody> 
            <tr v-for=" (item, index) in filteredData " :key="index"> 
              <td class="padding0"><span :class="'box '+item.tipo">{{ item.tipo.substring(0,1).toUpperCase() }}</span></td>
              <th>{{ index + 1 }}</th>
              <td>{{ item.fecha }}</td> 
              <td>{{ item.consorcio }}</td> 
              <td>{{ item.referencia }}</td>
              <td>{{ item.titulo }}</td>
              <td>{{ item.autor }}</td>
              <td>{{ item.codigo }}</td>
              <td>{{ item.cdu }}</td>
              <td class="align-right">{{ item.cantidad }}</td>
              <td class="align-right">{{ item.pendientes }}</td> 
              <td class="align-right">{{ item.enproceso }}</td>
              <td class="align-right"><span :title="item.incidencias_title">{{ item.incidencias }}</span></td>  
              <td class="align-right">{{ item.albaranados }}</td>                     
              <td>  
                <template v-for=" (elm, index) in item.albaranes ">                  
                <a 
                  :key="index"
                  v-if="elm.link" 
                  :href="getApiUrl + getLocale + '/' + elm.link + ( (getUserRole == 'badmin') ? ('&bibl=' + getActiveBiblioteca) : '')" 
                  :title=" elm.title "
                  class="ml5"
                  target="_blank"><i class="fa fa-file-pdf-o"></i></a>
                </template>
              </td>
            </tr> 
          </tbody> 
        </table>
      </template>

    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Por artículos": "Por artículos",
    "Título": "Título",
    "Autor/a - Intérprete - Director/a": "Autor/a - Intérprete - Director/a",
    "Autor": "Autor",
    "Código": "Código",
    "Pendientes": "Pendientes",
    "En Proceso": "En Proceso",
    "Incidencias": "Incidencias",
    "Albaranados": "Albaranados",
    "Fecha del pedido": "Fecha del pedido",
    "Buscar": "Buscar",
    "Debe rellenar un campo como mínimo": "Debe rellenar un campo como mínimo",
    "Proyecto": "Proyecto",
    "Fecha": "Fecha",
    "Artículo": "Artículo",
    "Cantidad": "Cantidad",
    "Referencia": "Referencia",
    "CDU": "CDU",
    "Situación": "Situación",
    "Todos": "Todos",
    "Pendiente": "Pendiente",
    "En Tatarana": "En Tatarana",
    "Incidencia": "Incidencia",
    "Facturado": "Facturado",
    "Vaciar": "Vaciar",
    "Buscar": "Buscar",
    "Guardar": "Guardar",
    "Editor": "Editor",
    "Distribuidor": "Distribuidor"
  },
  "en": {
  },
  "ca": {
    "Por artículos": "Per articles",
    "Título": "Títol",
    "Autor/a - Intérprete - Director/a": "Autor/a - Intèrpret - Director/a",
    "Autor": "Autor",
    "Código": "Codi",
    "Pendientes": "Pendents",
    "En Proceso": "En Procés",
    "Incidencias": "Incidencies",
    "Albaranados": "Albaranats",
    "Fecha del pedido": "Data de la comanda",
    "Buscar": "Buscar",
    "Debe rellenar un campo como mínimo": "S'ha d'omplir un camp com a mínim",
    "Proyecto": "Projecte",
    "Fecha": "Data",
    "Artículo": "Article",
    "Cantidad": "Quantitat",
    "Referencia": "Referència",
    "CDU": "CDU",
    "Situación": "Situació",
    "Todos": "Tots",
    "Pendiente": "Pendent",
    "En Tatarana": "A Tatarana",
    "Incidencia": "Incidència",
    "Facturado": "Facturat",
    "Vaciar": "Buidar",
    "Buscar": "Buscar",
    "Guardar": "Guardar",
    "Editor": "Editor",
    "Distribuidor": "Distribuïdor"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import UsuarioInputAutocomplete from './UsuarioInputAutocomplete.vue';
  import UsuarioCustomSelectBox from './UsuarioCustomSelectBox.vue';
  import { mapGetters } from 'vuex';

  export default {
    components: { UsuarioInputAutocomplete, UsuarioCustomSelectBox },
    data: () => {
      return{
        frm:{
          codigo: '',
          titulo: '',
          autor: '',
          editor: '',
          distrubuidor: '',
          fecha: ''
        },
        frm_response: '',
        frm_error: false,
        frm_error_message: '',
        loading: false,
        reset: false,
        articulos: '',
        sortKey: '',
        sortOrders: { fecha: 1, consorcio: 1, referencia: 1, titulo: 1, autor: 1, codigo: 1, cdu: 1 , cantidad: 1, pendientes: 1, enproceso: 1, incidencias: 1, albaranados: 1 },
        enlaceExcel: '',
      }
    },
    mounted(){
    },
    computed:{
      ...mapGetters(['getLocale', 'getApiUrl', 'getUserRole', 'getActiveBiblioteca']), 
      filteredData: function () {
        var sortKey = this.sortKey
        var order = this.sortOrders[sortKey] || 1
        var data = this.articulos
        if (sortKey && data) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      }
    },
    methods: {
      submitSearch() {
        this.frm_success = false;
        this.frm_error = false;

        if( this.searchData() ){
          this.showLoading();

          // COPIAR VARIABLES RELLENADAS
          let dataToSend = {};
          for (var prop in this.frm) {
            if (this.frm.hasOwnProperty(prop)) {
              if( this.frm[prop] != '' ){
                dataToSend[prop] = this.frm[prop];
                // INICIO CONSORCIOS
                if(this.getUserRole == 'badmin'){
                   dataToSend['bibl'] = this.getActiveBiblioteca;
                }
                // FIN CONSORCIOS
              }
            }
          }

          axios.get( this.getApiUrl + this.getLocale + '/misconsultas/articulo', {
            params: dataToSend
          })
          .then( (respuesta) =>{ 
            this.articulos = respuesta.data.data.articulos; 
            this.enlaceExcel = respuesta.data.data.enlace_excel;     
            this.hideLoading();

          })
          .catch( (error) =>{ 
            //console.log(error);
            //this.frm_error_message = error;
            this.frm_error_message = error.response.data.msg;
            this.frm_error = true;
            this.hideLoading();
          });
        }else{
          this.frm_error_message = this.$t('Debe rellenar un campo como mínimo');
          this.frm_error = true;
        }
      },
      resetForm(){
        this.reset = !this.reset;
        this.frm.codigo = this.frm.title = this.frm.author = this.frm.date = '';
        this.articulos = '';
        this.error = false;
        this.error_message = '';
      },
      searchData(){
        for (var prop in this.frm) {
          if (this.frm.hasOwnProperty(prop)) {
            if( this.frm[prop] != '' ){
              return true;
            }
          }
        }
        return false;
      },
      sortBy(key){
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },      
    },
    watch:{
    }
  }
</script>
